<template>
  <div class="alerts-wrapper">
    <v-alert
      v-for="(alert, index) in alerts"
      :key="'alert-' + index + '-' + alert.message"
      :border="alert.border"
      :color="alert.color"
      :dismissible="true"
      :type="alert.type"
    >
      {{ alert.message }}
    </v-alert>
  </div>
</template>

<script>
import { mapState } from 'vuex'

export default {
  name: 'Alerts',
  computed: {
    ...mapState('alertStore', {
      alerts: 'alerts',
    }),
  },
}
</script>

<style lang="scss" scoped>
.alerts-wrapper {
  position: fixed;
  bottom: 0;
  left: 50%;
  z-index: 1000;
  max-width: 90%;

  transform: translateX(-50%);

  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

::v-deep {
  .v-alert__border {
    left: 0;
  }

  .v-alert {
    width: 500px;
    max-width: 100%;
    margin-bottom: 8px;
    padding: 8px 12px;

    font-size: 22px;

    &.success {
      background-color: $primaryGreen !important;
      border-color: $primaryGreen !important;
    }

    &.error {
      background-color: $primaryRed !important;
      border-color: $primaryRed !important;
    }
  }
}
</style>
